import request from '../../Request';
import AppConfig from 'qs-config/AppConfig';

export const getCustomProperties = () =>
  request.authGet(`${AppConfig.qsApiEndPoint}/v1/custom-product-properties`);
